export default __webpack_public_path__ + "static/media/totals_bg_mobile.026a8cc2.svg";